import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background: ${props => props.background ?
        `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${props.background})` :
        props.backgroundColor || '#282E33'};
    background-size: cover;
    background-position: center;
    border-radius: 8px;
    width: 90%;
    max-width: 480px;
    height: auto; /* Changed to auto for content flexibility */
    max-height: 90vh; /* Added max-height */
    display: flex;
    flex-direction: column;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    overflow: hidden;

    @media (max-width: 768px) {
        width: 100%;
        height: 100%;
        border-radius: 0;
    }
`;

export const ModalInnerContent = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px; /* Added padding */
    overflow-y: auto; /* Added scroll for content */

    /* Webkit browsers (Chrome, Safari) */
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        
        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }

    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ModalHeader = styled.div`
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    h2 {
        margin: 0;
        color: ${props => props.textColor || '#fff'};
        font-size: 18px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-grow: 1; /* Allow title to take available space */
    }

    & > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
    }
`;

export const HeaderButton = styled.button`
    background: none;
    border: none;
    color: ${props => props.textColor || 'rgba(255, 255, 255, 0.7)'};
    font-size: 20px; /* Adjusted for icon size */
    cursor: pointer;
    padding: 0 4px; /* Adjusted padding */
    line-height: 1;
    display: flex; /* To center icon */
    align-items: center;
    justify-content: center;

    &:hover {
        color: #fff;
    }
`;

export const ProjectTitle = styled.h2`
    color: #fff;
    font-size: 24px;
    margin-bottom: 8px;
`;

export const ProjectTagline = styled.p`
    color: ${props => props.textColor || 'rgba(255, 255, 255, 0.8)'};
    font-size: 16px;
    margin-bottom: 16px;
`;

export const ProjectUrl = styled.a`
    color: ${props => props.textColor || '#0079BF'};
    font-size: 14px;
    margin-bottom: 16px;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const ProjectDescription = styled.div` /* Changed to div for Quill */
    color: ${props => props.textColor || 'rgba(255, 255, 255, 0.9)'};
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 24px;

    ul, ol {
        padding-left: 20px;
    }

    a, a:visited {
        color: white;
        font-weight: bold;
        text-decoration: underline;
    }
`;

export const SaveButton = styled.button`
    background: #0079BF;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s ease;
    align-self: flex-end; /* Align button to the end */
    margin-top: 16px;

    &:hover {
        background: #005f99;
    }
`;